module.exports = __webpack_public_path__ + "static/media/Siddhant_Jain.d9f0b9b4.jpg";